import React, { FC } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { getContentImagePath } from '@affstore-ds/images'
import { ErrorBlock, Image } from '@affstore-ds/uikit'

import { commonTranslationKeys } from '../../translations/common.translationKeys'
import { TableEmptyDataInterface } from './TableEmptyData.types'

export const TableEmptyData: FC<TableEmptyDataInterface> = (properties) => {
  const { title, description, mb = 52, mt = 48, withDescription = true, ...rest } = properties
  const { i18n } = useI18n()

  return (
    <ErrorBlock
      data-testid="table-empty-data"
      title={title ?? i18n.t(commonTranslationKeys.commonNoData)}
      description={withDescription ? (description ?? i18n.t(commonTranslationKeys.tableError)) : undefined}
      icon={<Image width={156} mb={26} src={getContentImagePath('EmptyBox')} />}
      mb={mb}
      mt={mt}
      withIcon
      {...rest}
    />
  )
}
